// settings/HamburgerMenu/sections/ConversationSection.tsx
import React from "react";
import Accordion from "~/components/utils/Accordion";
import { useTranslation } from "react-i18next";
import ConversationSettings from "~/components/ConversationSettings";

const ConversationSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Accordion
      items={[
        {
          title: t("conversationSettings"),
          content: <ConversationSettings />,
          dynamicHeight: true,
          isInfo: true,
        },
      ]}
    />
  );
};

export default ConversationSection;
